module.exports = __webpack_public_path__ + "img/order-step7-c.b16c668d.png";